export default {
  text: {
    type: 'string',
    required: true,
    maxSize: 65000,
  },
  attachmentPaths: {
    type: 'array',
  },
};
